import invoiceService from "./invoiceService";

const POLL_INTERVAL_MS = 5000;
const POLL_MAX_MS = 120000;

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Firma una factura en el SRI. Devuelve el mismo { success, message, data }
 * que el endpoint de firma.
 *
 * Si la conexión se corta sin respuesta ("Network Error"), normalmente es el
 * balanceador cerrando un request de más de 60 s mientras el backend sigue
 * firmando. En vez de reportar un error falso, se consulta el estado de la
 * factura hasta que la firma termine.
 */
export async function signInvoiceSRI(invoiceId) {
  try {
    const response = await invoiceService.sendInvoiceSRI({
      user_business_invoice_id: invoiceId
    });
    return response.data;
  } catch (error) {
    if (error?.response) throw error;
    return waitForSignature(invoiceId);
  }
}

async function waitForSignature(invoiceId) {
  const deadline = Date.now() + POLL_MAX_MS;
  let lastData;
  let firstUpdatedAt;

  while (Date.now() < deadline) {
    await sleep(POLL_INTERVAL_MS);
    try {
      const response = await invoiceService.verifyInvoiceSRI(
        { user_business_invoice_id: invoiceId },
        { skipNetworkErrorNotification: true }
      );
      const { success, message, data } = response.data || {};
      if (success) return { success: true, message, data };
      if (!data) continue;

      lastData = data;
      if (firstUpdatedAt === undefined) {
        firstUpdatedAt = data.updated_at;
        continue;
      }
      // El backend terminó el intento sin autorizar: devolver su mensaje
      const finished = ["failed", "timeout"].includes(data.status);
      if (finished && data.updated_at !== firstUpdatedAt) {
        return {
          success: false,
          message: data.sri_sign_message || message,
          data
        };
      }
    } catch (e) {
      // Error transitorio consultando el estado: seguir esperando
    }
  }

  return {
    success: false,
    message:
      "El SRI está tardando en responder. La firma puede completarse en unos minutos: revisa el estado de la factura antes de volver a firmar.",
    data: lastData
  };
}
